import { useCallback } from "react";
import { AlmeMessageEventData } from "@alme/post-message-api/AlmeMessageEventData";
import { AlmeLaunchIvaMessageEventData } from "@alme/post-message-api/AlmeLaunchIvaMessageEventData";
import defaultLogger from '../Logger';

export function useGetPersonaConfigCallback(
    setPersonaState: (verintAccessKey: string) => void,
): (payload: AlmeMessageEventData) => void {

    return useCallback((payload: AlmeMessageEventData): void => {
        const launchPayload = payload as AlmeLaunchIvaMessageEventData;
        try {
            if (typeof launchPayload?.message?.type === "string" && launchPayload?.message?.type?.toLowerCase() === 'launchiva') {
                defaultLogger.log('useGetTenantConfigCallback: ', launchPayload);
                const accessKey = launchPayload.message.accessKey || undefined;
                if (accessKey && typeof accessKey === "string") {
                    setPersonaState(accessKey);
                }
            }
        } catch (error) {
            defaultLogger.error('Error executing getTenantConfig callback', error);
        }
    }, [setPersonaState]);
}